import { c as _c } from "react/compiler-runtime";
import useBookingTranslation from "@modules/booking/lib/hooks/useBookingTranslation";
import InfoCard from "../InfoCard";
import StatusIcon from "../StatusIcon";
const ReconfirmationComplete = () => {
  const $ = _c(33);
  const {
    t
  } = useBookingTranslation();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <StatusIcon color="success" icon="Check" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("reconfirmationComplete.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <h2 className="text-h2 font-semibold">{t1}</h2>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("reconfirmationComplete.received");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <p className="mb-s">{t3}</p>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("reconfirmationComplete.callback");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <p className="mb-s">{t5}</p>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("reconfirmationComplete.nextStepsTitle");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t("reconfirmationComplete.nextSteps.email");
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = t("reconfirmationComplete.nextSteps.phone");
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t("reconfirmationComplete.nextSteps.appointment");
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t8 || $[23] !== t9) {
    t11 = [t8, t9, t10];
    $[21] = t10;
    $[22] = t8;
    $[23] = t9;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11 || $[26] !== t7) {
    t12 = <InfoCard title={t7} list={t11} />;
    $[25] = t11;
    $[26] = t7;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t12 || $[29] !== t2 || $[30] !== t4 || $[31] !== t6) {
    t13 = <div className="flex flex-col gap-3s items-center text-center w-[600px] max-w-full">{t0}{t2}{t4}{t6}{t12}</div>;
    $[28] = t12;
    $[29] = t2;
    $[30] = t4;
    $[31] = t6;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  return t13;
};
export default ReconfirmationComplete;